import { Fragment, useEffect, useState, useCallback } from 'react';
import { Row, Col, Spin } from 'antd';
import { useLocation } from 'react-router-dom';
import { admissionService } from '../../services/admission';
import config from '../../config';
import parse from 'html-react-parser';
const { format } = require('rut.js');

const ConsentPopupPage = () => {
  const [loading, setLoading] = useState(false);
  const [consentData, setConsentData] = useState();
  const [validationState, setValidationState] = useState();
  const [checkboxState, setCheckboxState] = useState(false);
  const { search } = useLocation();
  const [signerType, setSignerType] = useState('');
  const [queryParams, setQueryParams] = useState({});

  const getBrowserParams = useCallback((search) => {
    const findParams = new URLSearchParams(search);
    const params = {
      "from": findParams.get('from'),
      "sessionId": findParams.get('sessionId'),
      "patientId": findParams.get('patientId'),
      "patientEmail": findParams.get('patientEmail'),
      "reservationId": findParams.get('reservationId'),
      "consentType": findParams.get('consentType'),
      "signerType": findParams.get('signerType'),
      "companyDocumentNumber": findParams.get('companyDocumentNumber'),
      "companyDocumentType": findParams.get('companyDocumentType'),
      "companyName": decodeURIComponent(findParams.get('companyName')),
      "userFirstName": findParams.get('userFirstName'),
      "userLastName": findParams.get('userLastName'),
      "userDocumentType": findParams.get('userDocumentType'),
      "userDocumentNumber": findParams.get('userDocumentType') === 'rut'
        ? format(findParams.get('userDocumentNumber'), { dots: false })
        : findParams.get('userDocumentNumber'),
      "dateBirth": findParams.get('dateBirth'),
      "profession": findParams.get('profession') ? findParams.get('profession') : null,
      "phone": findParams.get('phone') ? findParams.get('phone') : null,
      "consentIndex": findParams.get('consentIndex'),
      "consentStatus": findParams.get('consentStatus'),
      "branchOfficeId": findParams.get('branchOfficeId'),
      "communeId": findParams.get('communeId'),
      "address": findParams.get('address'),
      "evaluationType": findParams.get('evaluationType'),
      "prestationNames": decodeURIComponent(findParams.get('prestationNames')),
    };

    setQueryParams(params);
    return params;
  }, [setSignerType]);


  const setHtmlBodyToConsent = async (params) => {
    const response = await admissionService.getPopupConsent(params);
    setConsentData(response.html);
  }

  const initState = useCallback(async () => {
    setLoading(true);
    const params = getBrowserParams(search);
    if (params) {
      await setHtmlBodyToConsent(params);

      setValidationState(validationState => {
        return {
          ...validationState,
          'consentIndex': params.consentIndex,
        }
      });

      setCheckboxState(params.consentStatus === 'false' ? false : true);

    }

    setLoading(false);
  }, []);

  const handleConsent = useCallback((boolean, token, data) => {
    let message = {
      'consentIndex': validationState['consentIndex'],
      'consentStatus': boolean,
      'token': token,
      'signerType': 'basic',
      'consentingId': data?.consentingId,
      'image': data?.image,
    };

    window.opener && window.opener.postMessage(message, '*')
  }, [validationState]);

  const signerRoutes = {
    'basic': '/basicSign',
  }

  const addQueryParams = (url, params) => {
    const queryParams = Object.entries(params)
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    return `${url}?${queryParams}`;
  }

  const listenerBrowser = (url) => {
    window.addEventListener('message', (event) => {
      if (url.startsWith(event.origin)) {
        if (event.data.error) {
          window.close();
        };
        handleConsent(true, null, (event.data.message ?? event.data));
        window.close();
      }
    }, false);
  }

  const openSignerPopUp = useCallback(() => {
    let url = config.validatorUrl + signerRoutes[signerType];
    let target = '_blank';
    let options = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=0,height=0,left=-1500,top=-1500`;

    listenerBrowser(url);

    window.open(addQueryParams(url, queryParams), target, options)
  }, [handleConsent]);

  useEffect(() => {
    initState();
  }, [initState]);

  useEffect(() => {
    if (validationState && queryParams.from === 'signer') {
      openSignerPopUp();
    }
  }, [validationState, openSignerPopUp]);


  return (
    <Row justify="center" className='consent-page'>

      <Col lg={22} xs={22}>
        {
          loading ?
            <Row justify="center">
              <Spin className="cmt-spin margin-top" />
            </Row>
            :
            consentData &&
            <Fragment>
              <Row justify='center' className='mt-30'>
                <h1 className="text-center">Consentimiento informado</h1>
              </Row>
              <div className='consent-text-wrapper'>
                {parse(consentData, { trim: true, })}
              </div>
              <Row justify='center' className='consent-check-wrapper pt-20 mb-30'>
                <Col lg={24} xs={24}>
                  <Row justify="center" align='middle'>
                    <Col>
                      <p className={`${checkboxState ? 'approval-text' : undefined} mb-0 mr-15`}>Acepto</p>
                    </Col>
                    <Col className={`checkbox-content ${checkboxState ? 'approved' : undefined}`}>
                      <div className='check-wrapper'>
                        <div className={checkboxState ? 'tick' : undefined} />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Fragment>
        }
      </Col>
    </Row>
  );
};

export default ConsentPopupPage;